import React, { useEffect, useMemo, useRef, useState } from "react";
import { Row, Col, Button, Form, Input } from "reactstrap";
import CustomForm from "../../custom/Forms/CustomForm";
import SelectInput from "../../custom/components/Select-Input/SelectInput";
import TextInput from "../../custom/components/Text-Input/TextInput";
import { Link, useNavigate, useParams } from "react-router-dom";
import { createPageData, sparePartRequestFormData } from "./ScrapFile";
import { getRecords, saveRecords } from "../../services/api.service";
import { toast } from "react-toastify";
import { TransactionalValidation } from "../../custom/validations/TransactionalValidation";
import CheckboxInput from "../../custom/components/CheckBox-Input/CheckboxInput";
import Asterisks from "../../custom/components/Asterisks/Asterisks";
import CustomError from "../../custom/components/Errors/CustomError";
import { imageURL } from "../../services/api.service";
import NumberInput from "../../custom/components/Number-Input/NumberInput";
import TextAreaInput from "../../custom/components/TextArea-Input/TextAreaInput";
import { validate } from "../../custom/validations/Validate";
import { LoaderCreatePage } from "../Loader/Loader";
import { loaderOverlay } from "../../Style/loaderOverly";
import DatePicker from "../../custom/components/Date-Picker/DatePicker";

const ScrapCreate = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    referenceOptions,
  } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(sparePartRequestFormData());
  const [invoiceSelect, setInvoiceSelect] = useState("");
  const [invoiceSelectOptions, setInvoiceSelectOptions] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const delivery_challen_doc_ref = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [filteredItems, setFilteredItems] = useState(
    formData?.inputData?.inward_items || []
  );
  const [selectedJobCard, setSelectedJobCard] = useState(null);
  const [jobCardSelectOptions, setJobCardSelectOptions] = useState([]);

  const [selectedScrapReason, setSelectedScrapReason] = useState(null);
  const [scrapReasonSelectOptions, setScrapReasonSelectOptions] = useState([]);

  const [selectedIntake, setSelectedIntake] = useState(null);
  const [intakeSelectOptions, setIntakeSelectOptions] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState(null);
  const [statusSelectOptions, setStatusSelectOptions] = useState([
    { value: 1, label: "Pending" },
    { value: 2, label: "Issued" },
    { value: 3, label: "Cancelled" },
  ]);

  const schema = localStorage.getItem("schema");

  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  const getEditData = async (id) => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        include: initialPayload?.include,
      };

      if (id) {
        payload.whereCondition = { id };
      }

      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data?.length > 0) {
        let data = responseData.data[0];

        setFormData({ inputData: data });

        // Safely set job card
        setSelectedJobCard({
          value: data?.job_card_id || null,
          label: data?.job_card?.job_card_no || "-",
        });

        // Safely set spare
        setSelectedScrapReason({
          value: data?.reason?.id || null,
          label: data?.reason?.reason || "-",
        });
        setSelectedIntake({
          value: data?.intake?.id || null,
          label: data?.intake?.intake_no || "-",
        });

        // Status selection
        const foundStatus = statusSelectOptions.find(
          (sts) => sts.label === data?.status
        );

        if (foundStatus) {
          setSelectedStatus({
            value: foundStatus.value,
            label: foundStatus.label,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const onInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    const fieldError = validate(validationType, {
      [name]: value,
    });
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError[name] || null,
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        [name]: type === "checkbox" ? (checked === true ? true : false) : value,
      },
    }));
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setLoadingData(true);

      const userDetails = JSON.parse(localStorage.getItem("authUser"));
      const validationErrors = validate(validationType, formData.inputData);
      console.log(
        "validationErrors",
        validationErrors,
        validationType,
        formData.inputData
      );
      setFormErrors(validationErrors);
      if (JSON.stringify(validationErrors) !== "{}") return;
      // Additional validation for `user_documents`

      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
      };

      if (id) {
        // update
        formData.inputData.updated_by = id ? userDetails?.id || "" : "";
        payload = { ...payload, id: id, inputData: formData.inputData };
      } else {
        // create
        formData.inputData.created_by = userDetails?.id || "";
        formData.inputData.updated_by = userDetails?.id || "";
        payload = { ...payload, inputData: formData.inputData };
      }
      const now = new Date();

      payload.inputData = {
        ...payload.inputData,
      };

      console.log(payload);
      // return;
      const responseData = id
        ? await saveRecords(payload, updateEndpoint)
        : await saveRecords(payload, createEndpoint);

      // Handle response
      if (responseData && responseData.code === 1) {
        toast.success(
          `${headerName} ${id ? "updated" : "saved"} successfully!`
        );
        navigate(navigatePage?.back);
      } else {
        toast.error(
          responseData.message || `Error while saving ${headerName}!`
        );
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    getJobCardData();
    getScrapReasonData();
    getIntakeData();
  }, []);

  const getJobCardData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: "job_cards",
        whereCondition: {
          is_active: true,
        },
        schema: schema,
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item.id,
        label: item.job_card_no,
      }));
      setJobCardSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };

  const handleJobCardSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      job_card_id: selectedValue,
    });

    setSelectedJobCard(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      job_card_id: fieldError?.job_card_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        job_card_id: selectedValue,
      },
    }));
  };

  const getScrapReasonData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: "scrap_reason_masters",
        whereCondition: {
          is_active: true,
        },
        schema: schema,
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item.id,
        label: item.reason,
      }));
      setScrapReasonSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };

  const handleScrapReasonSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      scrap_reason_id: selectedValue,
    });

    setSelectedScrapReason(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      scrap_reason_id: fieldError?.scrap_reason_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        scrap_reason_id: selectedValue,
      },
    }));
  };
  const getIntakeData = async () => {
    setLoadingData(true);
    try {
      let payload = {
        modelName: "material_intakes",
        whereCondition: {
          is_active: true,
        },
        schema: schema,
      };

      const responseData = await getRecords(payload, "/getRecords");
      const newArray = responseData.data?.map((item) => ({
        value: item?.id,
        label: item?.intake_no,
      }));
      setIntakeSelectOptions(newArray);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoadingData(false);
  };

  const handleIntakeSelect = (options) => {
    const selectedValue = options ? options.value : "";
    const fieldError = validate(validationType, {
      intake_id: selectedValue,
    });

    setSelectedIntake(options);
    setFormErrors((prevErrors) => ({
      ...prevErrors,
      intake_id: fieldError?.intake_id || "",
    }));

    setFormData((prevState) => ({
      ...prevState,
      inputData: {
        ...prevState.inputData,
        intake_id: selectedValue,
      },
    }));
  };

  return (
    <CustomForm
      title={id ? "UPDATE " + headerName : "CREATE " + headerName}
      loadingData={loadingData}
      onFormSubmit={handleSubmit}
      handleBackClick={() => navigate(navigatePage?.back)}
      id={id}
    >
      <Row className="mt-2">
        <Col md="6" className="mt-3">
          <SelectInput
            label="Intake"
            options={intakeSelectOptions}
            value={selectedIntake}
            onSelect={handleIntakeSelect}
            placeholder="Select Intake"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.intake_id}
          />
        </Col>

        <Col md="6" className="mt-3">
          <SelectInput
            label="Job Card"
            options={jobCardSelectOptions}
            value={selectedJobCard}
            onSelect={handleJobCardSelect}
            placeholder="Select Job Card"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.job_card_id}
          />
        </Col>
        <Col md="6" className="mt-3">
          <SelectInput
            label="Scrap Reason"
            options={scrapReasonSelectOptions}
            value={selectedScrapReason}
            onSelect={handleScrapReasonSelect}
            placeholder="Select Spare Part"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.scrap_reason_id}
          />
        </Col>

        {/* <Col md="6" className="mt-3">
          <TextInput
            label="Issue Qty"
            name="issue_qty"
            value={formData?.inputData?.issue_qty}
            onChange={onInputChange}
            placeholder="Issue Qty"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.issue_qty}
          />
          
        </Col> */}
        <Col md="6" className="mt-3">
          <TextAreaInput
            label="Remark"
            name="remark"
            value={formData?.inputData?.remark}
            onChange={onInputChange}
            placeholder="Remark"
            inputClassName="form-control"
            labelClassName="form-label"
            asterisk={true}
            customError={formErrors?.remark}
          />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col lg="12">
          <CheckboxInput
            name="is_active"
            label="Is Active"
            value={formData?.inputData?.is_active}
            checked={formData?.inputData?.is_active}
            handleTextChange={onInputChange}
            parentClassName="form-check"
            checkBoxClassName="form-check-input"
            labelClassName="form-check-label"
          />
        </Col>
      </Row>
      {loadingData && (
        <div style={loaderOverlay}>
          <LoaderCreatePage />
        </div>
      )}
    </CustomForm>
  );
};

export default ScrapCreate;
